import { observer } from 'mobx-react-lite'
import { type DraftJobViewModel } from '@/features/jobs/drafting/DraftJobViewModel'
import { type QuestionStepViewModel } from '@/features/jobs/drafting/IntakeQuestionsViewModel'
import { CompactLegendSelectorContainer } from '@/features/jobs/drafting/components/JobCreation/JobCreationFormView/CompactLegendSelectorContainer'
import { renderStepContent } from '@/features/jobs/drafting/components/JobCreation/JobCreationFormView/render-step-content'
import { StepContainer } from '@/features/jobs/drafting/components/JobCreation/JobCreationFormView/Step/StepContainer'
import { type CallCenterJobViewModel } from '@/features/call-center/JobSection/CallCenterJobViewModel'
import {
  CallCenterJobCreationForm,
  CallCenterLegendStepContent,
  CallCenterQuestionStepContent,
} from '@/features/call-center/JobSection/CallCenterJobCreationForm'

export interface CallCenterJobCreationFormContainerProps {
  vm: CallCenterJobViewModel
  jobCreation: DraftJobViewModel
}

export const CallCenterJobCreationFormContainer = observer(
  function CallCenterJobCreationFormContainer({
    vm,
    jobCreation,
  }: CallCenterJobCreationFormContainerProps) {
    const jobWasCreated = jobCreation.jobWasCreated

    return (
      <CallCenterJobCreationForm isEmpty={vm.isFormEmpty}>
        {vm.legendSteps.map((stepContainer) => (
          <StepContainer
            key={stepContainer.step.stepId}
            stepAccessor={stepContainer}
            compact
          >
            <CallCenterLegendStepContent>
              {vm.taxTypeLegends.length > 0 && (
                <CompactLegendSelectorContainer
                  vm={stepContainer}
                  isDisabled={jobWasCreated}
                  searchResults={vm.taxTypeLegends}
                />
              )}
            </CallCenterLegendStepContent>
          </StepContainer>
        ))}

        {vm.requiredQuestionSteps.map((stepContainer) =>
          renderQuestionStep(stepContainer, true, jobWasCreated),
        )}

        {vm.optionalQuestionSteps.map((stepContainer) =>
          renderQuestionStep(stepContainer, false, jobWasCreated),
        )}
      </CallCenterJobCreationForm>
    )
  },
)

function renderQuestionStep(
  stepContainer: QuestionStepViewModel,
  isRequired: boolean,
  jobWasCreated: boolean,
) {
  const stepContent = renderStepContent(stepContainer, {
    isLegendDisabled: jobWasCreated,
  })

  if (!stepContent) {
    return null
  }

  return (
    <StepContainer
      key={stepContainer.step.stepId}
      stepAccessor={stepContainer}
      compact
    >
      <CallCenterQuestionStepContent isRequired={isRequired}>
        {stepContent}
      </CallCenterQuestionStepContent>
    </StepContainer>
  )
}
